import React from 'react'
import Navbar from '../navbar/Navbar'
import ReusableComponent from '../../components/resusable/ReusableComponent'
import { insuranceInvestigation } from '../../data/pageData'
import Footer from '../../components/Footer/Footer'
import '../About/About.css'

const InsuranceInvestigation = () => {
  return (
    <div>
      <Navbar/>
       <div className=' .about__aside-details'> 
        <div className="aboutUs__image-asideContent">
          <h1 className='about__us-title'>{insuranceInvestigation.title}</h1>
          <img src={insuranceInvestigation.image} alt="about__us-img" />
          <div className='content-component'>
            <div className="content-paragraphes">
            <p className='content1'>{insuranceInvestigation.contentInsurance1}</p>
              <p className='content2'>{insuranceInvestigation.contentInsurance2}</p>
            <p className='content3'>{insuranceInvestigation.contentInsurance3}</p>
            <p className='content4'>{insuranceInvestigation.contentInsurance4}</p>
            </div>
          <ReusableComponent />
          </div>
          
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default InsuranceInvestigation